import { React } from '@/vendor'
import { Spinner } from '@/components'
import styles from './styles.module.scss'

export default () => (
	<div className={styles.appLoading}>
		<Spinner />
	</div>
)
